import ConfirmModalUI from '@/components/common/ConfirmModalUI/ConfirmModalUI'

interface DeleteModalProps {
  text?: string
  onClose?: () => void
}

const ControllerModal = ({ text, onClose }: DeleteModalProps) => {
  return (
    <ConfirmModalUI
      title="Error"
      text={text}
      onClose={onClose}
      cancelText="Close"
      sx={{
        '& .MuiDialogTitle-root .MuiTypography-root': {
          color: 'error.main',
        },
      }}
    ></ConfirmModalUI>
  )
}

export default ControllerModal
